module.exports = __webpack_public_path__ + "img/ru-ta.67c169ac.svg";